import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import nexusCrmTestReportMarkdown from '@/assets/Artifacts/nexus-crm-test-report.md?raw'
import nexusProcurementHtml from '@/assets/Artifacts/nexus-procurement.html?raw'
import {
  WEBSITE_CRM_CRM_INTEGRATION_INTRO_MARKDOWN,
  WEBSITE_CRM_STRIPE_MAILCHIMP_MARKDOWN,
} from './websiteCrmDemoContent.part01.js'
import {
  WEBSITE_CRM_CONNECTED_APP_BLOCKS,
  WEBSITE_CRM_CRM_TEST_LOG_BLOCK_INDEX,
} from './websiteCrmDemoContent.part03.js'
import {
  ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_BUILD,
  ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_INITIAL,
  ZOHO_CRM_INTEGRATION_BEFORE_BUILD_MARKDOWN,
} from './zohoCrmIntegrationDemoContent.js'
import { WEBSITE_CRM_AI_LOG_STEPS_CRM_TEST } from './websiteCrmDemoContent.part06.js'
import { buildWebsiteCrmDemoClosingBlocks } from './websiteCrmDemoContent.part09.js'

export function buildWebsiteCrmConnectFinalBlocks(zohoArtifactId, docArtifactId, htmlArtifactId) {
  return [
    { type: 'markdown', content: WEBSITE_CRM_CRM_INTEGRATION_INTRO_MARKDOWN },
    {
      type: 'aiResponseLog',
      status: 'ok',
      showLogStatus: false,
      steps: buildWorkflowTimeline(ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_INITIAL),
    },
    { type: 'markdown', content: ZOHO_CRM_INTEGRATION_BEFORE_BUILD_MARKDOWN },
    {
      type: 'aiResponseLog',
      status: 'ok',
      showLogStatus: false,
      steps: buildWorkflowTimeline(ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_BUILD),
    },
    { type: 'markdown', content: WEBSITE_CRM_STRIPE_MAILCHIMP_MARKDOWN },
    ...WEBSITE_CRM_CONNECTED_APP_BLOCKS,
    {
      type: 'aiResponseLog',
      status: 'ok',
      showLogStatus: false,
      steps: buildWorkflowTimeline(WEBSITE_CRM_AI_LOG_STEPS_CRM_TEST),
    },
    ...buildWebsiteCrmDemoClosingBlocks(htmlArtifactId, zohoArtifactId, docArtifactId),
  ]
}

export function buildWebsiteCrmHtmlArtifactPayload() {
  return {
    html: nexusProcurementHtml,
  }
}

export function buildWebsiteCrmDocArtifactPayload() {
  return {
    markdown: nexusCrmTestReportMarkdown,
  }
}
